/* ---------------------------------
-----  dimension variables --------
---------------------------------- */
/* ------  standard elements padding & margin  ------- */
/* spacing */
/**
**  Official Font sizes
------------------------------- */
/**
** Line-heights
------------------------------- */
/*
  Mixin to progressively-enhance :focus-visible, keeping :focus where not supported
  Add an arbitrary list of selectors into the arguments, and the styling in the block.
  I you pass no selectors to the mixin the parent ("ampersand") operator is used instead.

  There are two mixins:
  - focus-visible: a generic focus-visible, giving you "slots" to decide what to render for :focus, :focus reset, and :focus-visible
  - focus-visible-outline: a focus-visible, which only resets the outline. If you don't need more custom resets, use this one!

  Use focus-visible:
  The key thing here is checking which slot is being rendered.
  For example, you can reset box-shadow here, or anything else.

  @include focus-visible using ($slot) {
      @if $slot == focus {
          outline: 2px solid transparent;
          box-shadow: 0 0 0 4px blue;
      }
      @if $slot == focusReset {
          box-shadow: none;
      }
      @if $slot == focusVisible {
          box-shadow: 0 0 0 4px blue;
      }
  }

  Use focus-visible-outline:
  @include focus-visible-outline("button", "a[href]") {
      outline: 2px solid blue;
  }

  Resulting CSS (compressed):

  button:focus,
  a[href]:focus {
      outline: 2px solid blue;
  }

  button:focus:not(:focus-visible),
  a[href]:focus:not(:focus-visible) {
      outline: none;
  }
  button:focus-visible,
  a[href]:focus-visible {
      outline: 2px solid blue;
  }
*/
.ux-date-picker.ux-date-picker--disabled .ux-input[readonly] {
  cursor: not-allowed;
}

.ux-date-picker {
  display: block;
  flex: 1 0 auto;
  max-width: 100%;
  overflow: visible;
  position: relative;
  width: 290px;
}
.ux-date-picker button {
  align-items: center;
  appearance: none;
  background: transparent none;
  border: 0 none transparent;
  border-radius: 0;
  cursor: pointer;
  display: flex;
  flex: 0 0 auto;
  justify-content: center;
  outline: none;
}
.ux-date-picker .ux-input[readonly] {
  cursor: pointer;
}
.ux-date-picker__field {
  background-color: #fff;
  position: relative;
}
.ux-date-picker__field ux-icon {
  font-size: 24px;
  pointer-events: none;
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
}
.ux-date-picker__calendar, .ux-date-picker__container, .ux-date-picker__header, .ux-date-picker__footer, .ux-date-picker__title {
  align-items: stretch;
  display: flex;
  justify-content: stretch;
}
.ux-date-picker__container {
  background-color: #fff;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);
  flex-direction: column;
  margin-top: 10px;
  position: absolute;
  top: 100%;
  width: 290px;
  z-index: 100;
}
.ux-date-picker__header {
  background-color: #285172;
  color: #fff;
  flex: 1 0 auto;
  flex-flow: row nowrap;
}
.ux-date-picker__header button {
  color: #fff;
  height: 44px;
  width: 38px;
}
.ux-date-picker__header polygon,
.ux-date-picker__header path {
  fill: currentcolor;
}
.ux-date-picker__title {
  font-family: Frutiger-Bold, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizelegibility;
  font-weight: 400;
  align-items: center;
  flex: 1 0 auto;
  justify-content: center;
  padding: 0 15px;
  text-transform: uppercase;
}
.ux-date-picker__calendar {
  flex-flow: row wrap;
  padding: 10px 15px;
}
.ux-date-picker__calendar-head {
  font-family: Frutiger-Bold, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizelegibility;
  font-weight: 400;
  display: inline-block;
  font-size: 15px;
  height: 38px;
  text-transform: uppercase;
}
.ux-date-picker__footer {
  flex-flow: row wrap;
  justify-content: space-between;
  padding: 0 15px 15px;
}
.ux-date-picker__footer button {
  font-family: Frutiger-Roman, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizelegibility;
  font-weight: 400;
  font-size: 16px;
}

.ux-date-picker--kind-default input {
  caret-color: transparent;
  cursor: pointer;
  border: solid 1px #131313;
}
.ux-date-picker--kind-default .ux-label:not(.ux-date-picker__label--top) {
  align-items: center;
  background: #c6d4dd;
  color: #131313;
  display: flex;
  justify-content: center;
  margin: 0;
  padding: 0 15px;
  border: solid 1px #131313;
  border-right: 0;
}
.ux-date-picker--kind-default .ux-label:not(.ux-date-picker__label--top) .ux-label--error {
  display: none;
}
.ux-date-picker--kind-default .ux-input,
.ux-date-picker--kind-default .ux-input:focus {
  border-color: #131313;
}
.ux-date-picker--kind-default .ux-input--error {
  border-color: #ff0201;
}
.ux-date-picker--kind-default .ux-date-picker__field {
  flex-grow: 1;
}
.ux-date-picker--kind-default .ux-date-picker__field-wrapper {
  display: flex;
}

.ux-date-picker--kind-form .ux-label {
  display: block;
  font-size: 13px;
  line-height: 1.6;
  margin: 0 0 10px;
  padding: 0;
}
[dir=rtl] .ux-date-picker--kind-form .ux-label {
  display: flex;
  flex-flow: row wrap;
}
.ux-date-picker--kind-form .ux-label.ux-label--error {
  font-family: Frutiger-Light, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizelegibility;
  font-weight: 400;
  color: #ff0201;
}
.ux-date-picker--kind-form .ux-label ~ .ux-label {
  margin-left: 10px;
}
.ux-date-picker--kind-form .ux-input--error {
  border-color: #ff0201;
}

[dir=rtl] .ux-date-picker__header ux-icon {
  transform: scaleX(-1);
}

[dir=rtl] .ux-date-picker__field ux-icon {
  left: 15px;
  right: auto;
}

.ux-date-picker__calendar-day {
  align-items: center;
  display: flex;
  flex: 1 0 auto;
  font-size: 13px;
  justify-content: center;
  width: 14.2857142857%;
}
.ux-date-picker__calendar-day button {
  background-color: transparent;
  border-radius: 0;
  font-size: inherit;
  height: 38px;
  transition: background-color 250ms ease-out;
  width: 38px;
}
.ux-date-picker__calendar-day button:hover, .ux-date-picker__calendar-day button:focus {
  background-color: #d6e58f;
}
.ux-date-picker__calendar-day--disabled {
  cursor: not-allowed;
  opacity: 0.3;
}
.ux-date-picker__calendar-day--disabled button {
  pointer-events: none;
}
.ux-date-picker__calendar-day--inactive button {
  opacity: 0.3;
}
.ux-date-picker__calendar-day--highlighted {
  background-color: #ecf3cd;
}
.ux-date-picker__calendar-day--today button {
  background-color: #e7ecf0;
}
.ux-date-picker__calendar-day--selected button,
.ux-date-picker__calendar-day--selected button:hover,
.ux-date-picker__calendar-day--selected button:focus {
  background-color: #bbd03a;
}

/** Todo: remove interim styles when consistent error handling is merged **/
.ux-date-picker__label-container .ux-label.ux-label--error {
  font-family: Frutiger-Light, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizelegibility;
  font-weight: 400;
  color: #ff0201;
}